@if (!showAsChip()) {
	<form-field-label [labelTranslateKey]="'labels'" />
	<div class="label-container outlined-icon-btn">
		@for (label of selectedLabels(); track label.id) {
			<label-badge [label]="label" (closeIconClicked)="unlinkLabel($event)" />
		}

		<button
			mat-icon-button
			[matMenuTriggerFor]="labelListMenu"
			(menuOpened)="isMenuOpen.set(true)"
		>
			<mat-icon svgIcon="add" />
		</button>
	</div>
} @else {
	<div [matMenuTriggerFor]="labelListMenu">
		<mat-chip class="label-chip">
			@if (selectedLabels().length > 1) {
				{{ selectedLabels().length }}
				{{ 'labels_list' | translate: { count: selectedLabels().length.toString() } }}
			} @else if (selectedLabels().length === 1) {
				<span class="single-label-display">
					<span
						class="label-color-dot"
						[ngStyle]="{ 'background-color': selectedLabels()[0].color }"
					></span>
					{{ selectedLabels()[0].name }}
				</span>
			} @else {
				{{ 'label' | translate }}
			}
		</mat-chip>
	</div>
}

<mat-menu
	#labelListMenu
	xPosition="after"
	yPosition="below"
	(closed)="isMenuOpen.set(false)"
>
	<div
		class="label-list-menu nice-scroll colored-scroll-track visible-scroll"
		(click)="$event.stopPropagation()"
	>
		<labels-list
			[selectedLabels]="selectedLabels()"
			[isOpen]="isMenuOpen()"
			(labelsChanged)="onLabelsChanged($event)"
		/>
	</div>
</mat-menu>
